export default __webpack_public_path__ + "static/media/bigIcon2.f6ff3b46.png";